module.exports = __webpack_public_path__ + "img/howto_step1_img.c2ac72a6.png";